"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consumable = exports.Consumables = void 0;
const types_1 = require("@hoepel.app/types");
class Consumables {
    constructor(props) {
        this.props = props;
    }
    static createEmpty(tenantId) {
        return new Consumables({ tenantId, consumables: [] });
    }
    static fromProps(props) {
        return new Consumables(props);
    }
    toProps() {
        return this.props;
    }
    get id() {
        return `${this.tenantId}-consumables`;
    }
    get tenantId() {
        return this.props.tenantId;
    }
    get names() {
        return new Set(this.consumables.map((consumable) => consumable.name));
    }
    get namesSorted() {
        return [...this.names].sort();
    }
    get consumables() {
        return [
            ...this.props.consumables.map((props) => Consumable.fromProps(props)),
        ].sort((a, b) => a.name.localeCompare(b.name));
    }
    get isEmpty() {
        return this.consumables.length === 0;
    }
    withConsumableAdded(consumable) {
        if (!this.mayAddConsumable(consumable)) {
            return this;
        }
        return Consumables.fromProps({
            ...this.toProps(),
            consumables: [...this.toProps().consumables, consumable.toProps()],
        });
    }
    withConsumableRemoved(name) {
        return Consumables.fromProps({
            ...this.toProps(),
            consumables: this.toProps().consumables.filter((c) => c.name !== name),
        });
    }
    withChangedPriceForConsumable(name, newPriceCents) {
        if (!this.consumableWithNameExists(name)) {
            return this;
        }
        return Consumables.fromProps({
            ...this.toProps(),
            consumables: [
                ...this.toProps().consumables.filter((c) => c.name !== name),
                Consumable.create(name, newPriceCents).toProps(),
            ],
        });
    }
    withRenamedConsumable(oldName, newName) {
        const currentConsumable = this.findConsumableByName(oldName);
        if (this.consumableWithNameExists(newName) || currentConsumable == null) {
            return this;
        }
        return Consumables.fromProps({
            ...this.toProps(),
            consumables: [
                ...this.toProps().consumables.filter((c) => c.name !== oldName),
                currentConsumable.withName(newName).toProps(),
            ],
        });
    }
    findConsumableByName(name) {
        var _a;
        return ((_a = this.consumables.find((consumable) => consumable.name === name)) !== null && _a !== void 0 ? _a : null);
    }
    mayAddConsumable(consumable) {
        return !this.consumableWithNameExists(consumable.name);
    }
    consumableWithNameExists(name) {
        return this.findConsumableByName(name) != null;
    }
}
exports.Consumables = Consumables;
/**
 * Used to represent something that can be consumed or purchased, which is not an attendance.
 * E.g. drink, cookies, ...
 * Consumption of consumables is tied to a dayid/DayDate o(a specific date)
 * The same consumable can be consumed multiple times by the same child on the same day.
 */
class Consumable {
    constructor(props) {
        this.props = props;
    }
    static create(name, priceCents) {
        if (priceCents < 0) {
            throw new Error('Price in cents must be a positive number');
        }
        if (Math.round(priceCents) != priceCents) {
            throw new Error('Price in cents must be an integer');
        }
        return new Consumable({ name, priceCents });
    }
    static fromProps(props) {
        return new Consumable(props);
    }
    withName(newName) {
        return Consumable.fromProps({
            ...this.toProps(),
            name: newName,
        });
    }
    toProps() {
        return this.props;
    }
    /**
     * Price of the consumable. May not be included in fiscal certificates (these costs are non-refundable)!
     */
    get price() {
        return types_1.Price.fromCents(this.props.priceCents);
    }
    /**
     * Name of the consumable, e.g. "Big chocolate cookie"
     */
    get name() {
        return this.props.name;
    }
}
exports.Consumable = Consumable;
//# sourceMappingURL=consumables.js.map